import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP4UnderUtilizedOvw202603: FaireAdPerformancePeriodEntity = {
  token: "perf_p4_under_utilized_ovw_202603",
  type: "adPerformancePeriod",
  scope: "OVERVIEW",
  periodType: "RECEIPT",
  startDate: "2026-03-01",
  endDate: "2026-03-31",
  impressions: 15786,
  clicks: 254,
  adsSpendDollars: 1025,
  budgetDollars: 15000,
  salesDollars: 6171,
  bestEstimateRoas: 6.02,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.07,
  newCustomersAcquired: 4,
  reorderConversions: 8,
  dataAvailableAtDate: "2026-04-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
